module.exports = __webpack_public_path__ + "img/hzxc.231d3edb.png";